(function homeScript($, Drupal) {
  Drupal.behaviors.home = {
    attach: function (context, settings) {

      var timer = setInterval(myTimer, 100);
      function myTimer() {
        if ($('.slick-slider_rec .oo-ticker-pane').length > 0) {
          setTimeout(function () {
            $('.slick-slider_rec .oo-ticker-pane').slick({
              speed: 350,
              autoplay: true,
              autoplaySpeed: 3000,
              slidesToShow: 4,
              slidesToScroll: 1,
              adaptiveHeight: true,
              swipeToSlide: true,
              infinite: false,
              arrows: true,
              dots: true,
              outerEdgeLimit: true,
              responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                  }
                }]
            });
            $('.slick-slider_rec .oo-ticker-pane').slick('slickFilter', '.oo-ticker-item');
            if ($($('.oo-ticker-item')[0]).css('width') == '0px') {
              $('.slick-slider_rec .oo-ticker-pane').slick('unslick');
            } else {
              myStopFunction();
            }
          }, 500);
        }
      }

      function myStopFunction() {
        clearInterval(timer);
      }
    },
  };
}(jQuery, Drupal));
